import React from 'react';

export const ParametrosListaContexto = React.createContext(null);